import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className="footer">
            <div className="footer_contacts">
                <h3 className="footer_title">Contact Us</h3>
                <p className="footer_title">About Us</p>
                <p>Our careers</p>
                <p>Terms and Conditions</p> 
                <p>Privacy policy</p>
            </div>
            <div className="footer_subscribe">
                <h3 className="footer_title">Subscribe Us</h3>
                <p>Subscribe to our newsletter to get updates on our latest offers!</p>
                <form>
                    <input type="email" placeholder="Enter email"/>
                    <button>Subscribe</button>
                </form>

            </div>
            <div className="footer_social">
                <h3 className="footer_title">Join Us</h3>
                <a href="#">Facebook</a>
                <a href="#">Instagram</a>
                <a href="#">Twitter</a>
                <a href="#">WhatsApp</a>
            </div>
        </div>
    )
}

export default Footer;

